import type { IVaultNavHistory, Vault, } from "@bracket/types";
import { DateTime } from "luxon";



export declare type GetEpochStartTimeProps = {
	vault: Vault & IVaultNavHistory;
	epoch: number;
};



export const getEpochStartTime = ({
	vault,
	epoch,
}: GetEpochStartTimeProps): DateTime => {
	const { navs, launch_date, epoch_offset_hours, } = vault;
	const start = (typeof launch_date === "string" ? DateTime.fromISO(launch_date) : DateTime.fromJSDate(launch_date)).plus({ hours: epoch_offset_hours, });
	let time = Object.assign(start, {});
	for(const nav of Array.from(navs).sort((a, b) => a.epoch - b.epoch)) {
		if(nav.epoch === 0) {
			continue;
		}
		if(nav.epoch < epoch) {
			time = time.plus({ days: nav.epoch_duration_days, });
			continue;
		}
		break;
	}
	return time;
};
